'use strict'

function AjaxMonitor(axios) {
  window.numberOfAxiosCallPending = 0

  axios.interceptors.request.use(function (config) {
    window.numberOfAxiosCallPending++
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  axios.interceptors.response.use(function (response) {
    window.numberOfAxiosCallPending--
    return response
  }, function (error) {
    return Promise.reject(error)
  })

  return axios
}

export default AjaxMonitor
